export default "__VITE_ASSET__B7y5hyLA__"